import {
    WebUiConfigActionTypes,
    WebUiConfigReducerAction,
    WebUiConfigState,
    ExtendedWebUiConfig,
} from './types';

const emptyWebUiConfigState: ExtendedWebUiConfig = {
    client_id: '',
    client_name: '',
    client_logo_link_url: '',
    client_logo: null,
    support_phone: '',
    support_website: '',
    support_email: '',
    country_iso2: '',
    user_terms_requires_checkbox_confirmation: true,
    screening_journey_enabled: false,
    screening_steps: '',
    screening_title: '',
    screening_heading_one: '',
    screening_copy_one: '',
    screening_heading_two: '',
    screening_copy_two: '',
    screening_heading_three: '',
    screening_copy_three: '',
    change_product_name: false,
    subtitle: '',
    hero_image: null,
    introduction_body: '',
    change_information_banner: false,
    information_banner_content: '',
    guidance_step1: '',
    guidance_step2: '',
    guidance_step3: '',
    start_button_cta: '',
    member_verification_title: '',
    member_verification_outcome_copy: '',
    member_verification_header: '',
    member_verification_member_field: '',
    member_verification_tooltip: '',
    member_verification_error_message: '',
    member_verification_CTA: '',
    privacy_policy_template: 'privacy-page',
    faq_template: 'access-faq-page',
    full_terms_template: 'terms-page',
    terms_summary_template: 'user-terms-page',
};

export const initialTriageRegistrationConfigState: WebUiConfigState = {
    requestStatus: null,
    config: emptyWebUiConfigState,
    lastRequestTime: null,
};

const webUiConfigReducer = (
    state = initialTriageRegistrationConfigState,
    action: WebUiConfigReducerAction,
): WebUiConfigState => {
    switch (action.type) {
        case WebUiConfigActionTypes.SET_WEB_UI_CONFIG:
            return {
                ...state,
                config: action.payload.config as ExtendedWebUiConfig,
                lastRequestTime: action.payload.lastRequestTime,
            };
        case WebUiConfigActionTypes.SET_WEB_UI_CONFIG_REQUEST_STATUS:
            return {
                ...state,
                requestStatus: action.payload,
            };
        default:
            return state;
    }
};

export default webUiConfigReducer;
